<div class="single-select-dropdown-container">
  <button
		mat-stroked-button
    class="filter-button"
		[ngClass]="showMenu ? 'filter-button-focused' : 'filter-button-not-focused'"
    [matMenuTriggerFor]="dropdownSingleSelectMenu"
    #menuTrigger="matMenuTrigger"
	  (menuOpened)="handleMenuOpen()"
  >
    <span *ngIf="selectedOption" class="filter-button-label" [ngClass]="showMenu ? 'filter-button-label-focused' : 'filter-button-label-not-focused'">
      {{ dropdownLabel }}
    </span>

    <span class="filter-button-text" [ngClass]="selectedOption ? 'filter-button-text-value-selected' : 'filter-button-text-value-not-selected'">
      {{ selectedOption?.label || dropdownLabel }}
    </span>

    <mat-icon>{{ showMenu ? "arrow_drop_up" : "arrow_drop_down" }}</mat-icon>
  </button>

  <mat-menu
    #dropdownSingleSelectMenu="matMenu" xPosition="after" class="single-select-dropdown-menu" (closed)="handleMenuClose()"
  >
    <div
      #dialogWrapper
      cdkTrapFocus
      cdkTrapFocusAutoCapture="true"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="dropdownLabel"
      (keydown)="handleMenuKeydown($event)"
      (keydown.escape)="menuTrigger.closeMenu()"
    >
      <div *ngIf="showMenu" class="dropdown-option-container" tabindex="0" role="listbox" style="outline: none" (focus)="focusFirstOption()" (click)="$event.stopPropagation()">
        <div *ngFor="let option of displayOptions" class="option-wrapper" [ngClass]="{ 'option-wrapper-selected': potentiallySelectedOption?.value === option.value }">
          <button
            type="button"
            class="option"
            tabindex="-1"
            (click)="handleOptionClick(option)"
          >
            <img
              *ngIf="option.icon"
              class="option-icon"
              [src]="option.icon"
              alt=""
            />
            <span class="option-label">{{ option?.label }}</span>
          </button>
        </div>
      </div>
      <div class="action-button-container">
        <app-action-button
          title="cancel"
          type="outlined-1"
          [style.marginRight.px]="16"
          (buttonClicked)="menuTrigger.closeMenu()"
        ></app-action-button>

        <app-action-button
          title="apply"
          (buttonClicked)="dropdownSubmit()"
        ></app-action-button>
      </div>
    </div>
  </mat-menu>
</div>
